import { Navigate, useRoutes } from 'react-router-dom';
import SimpleLayout from './layouts/simple';
import EstimatePage from './pages/Estimate/index';
import BookingPage from './pages/Booking/index';
import AdminPage from './pages/Admin/index';

export default function Router() {
  const routesList = [
    {
      path: '/admin',
      element: <AdminPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/estimate" replace />, index: true },
        {
          path: '/',
          children: [
            {
              path: 'estimate',
              element: <EstimatePage />,
            },
            {
              path: 'booking',
              element: <BookingPage />,
            },
          ],
        },
        { path: '*', element: <Navigate to="/estimate" replace /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/estimate" replace />,
    },
  ];

  const routes = useRoutes(routesList);
  return routes;
}
